var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow",staticStyle:{"padding":"15px 30px","width":"100%"}},[_c('div',{ref:"scanActivityByMonth",staticClass:"chartStyle "})])}
var staticRenderFns = []

export { render, staticRenderFns }